import React, {useState, useEffect} from 'react';
import convert from 'convert-units';
import Select from 'react-select'
import StyledSelect from '../components/StyledSelect'

const categoryOptions = [
  'length', 'area', 'mass', 'volume', 'temperature', 'time', 'frequency', 'speed', 'pace',
  'pressure', 'digital', 'illuminance', 'voltage', 'current', 'power', 'energy', 'charge'
];
const options = []
categoryOptions.map((cate) => {
  options.push({ value: cate, label: cate.toUpperCase() })
})

const UnitConverter = (props) => {
  const { appTheme } = props
  const [selectedOption, setSelectedOption] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [unitOptions, setUnitOptions] = useState([])
  const [selectUnit, setSelectUnit] = useState('')
  const [selectConvertedUnit, setSelectConvertedUnit] = useState('')
  const [convertedValue, setConvertedValue] = useState('')

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    setSelectUnit('')
    setSelectConvertedUnit('')
  };

  const handleSelectUnit = (option) => {
    setSelectUnit(option);
    setSelectConvertedUnit('')
  };

  const handleSelectConvertedUnit = (option) => {
    setSelectConvertedUnit(option);
  }

  useEffect(() => {
    if (selectedOption) {
      const units = convert().possibilities(selectedOption.value);
      const unitOptions = []
      units.map((unit) => {
        unitOptions.push({ value: unit, label: unit.toUpperCase() })
      })
      setUnitOptions(unitOptions)
    }
    if (selectUnit && selectConvertedUnit && inputValue) {
      const convertedValue = convert(inputValue).from(selectUnit.value).to(selectConvertedUnit.value)
      setConvertedValue(convertedValue)
    } else {
      setConvertedValue('')
    }
  }, [selectedOption, selectUnit, selectConvertedUnit, inputValue]);

  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 h-80 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Unit Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <StyledSelect appTheme={appTheme} value={selectedOption} options={options} onChange={handleSelectChange} />
            <StyledSelect appTheme={appTheme} className='mt-4 dark:bg-gray-700' value={selectUnit} options={unitOptions} onChange={handleSelectUnit} />
            <input min={0} value={inputValue} onChange={(event) => setInputValue(event.target.value)} type="number" className="mt-5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Enter value here" required />
          </div>
        </div>
      </div>
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 h-80 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Unit Output</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <StyledSelect appTheme={appTheme} className='dark:bg-gray-700' value={selectConvertedUnit} options={unitOptions} onChange={handleSelectConvertedUnit} />
            <input value={convertedValue} disabled={true} type='text' className="mt-4 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Converted value here" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitConverter;
